module.exports = __webpack_public_path__ + "static/img/style_3.ff3a0bc0.png";